<template>
  <AppSection
    id="monitoring-jobs"
    type="section"
    :title="$getConst.pages.connectivity_test.pending_jobs"
  >
    <AppDataTable
      ref="pendingTable"
      :fields="fields"
      :end-point="endPoint"
    >

      <template v-slot:payload="item">
        #job-{{ item.row.id }} : {{ item.data.job }} ...
        <b-link @click="showPayloadDetails(item.row)" v-b-tooltip.hover
                  :title="$t($getConst.pages.button.show_more)"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

    </AppDataTable>
    <ShowPayloadDetailsModal v-if="job" :id="payloadDetailsModal" :job="job" size="xl"/>
  </AppSection>
</template>

<script>
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppDataTable from "../../../../components/common/table/AppDataTable";
  import ShowPayloadDetailsModal from "./ShowPayloadDetailsModal"

  export default {
    name: "jobsPending",
    components: {AppSpinner, AppSection, AppDataTable, ShowPayloadDetailsModal},
    props: {
      scope_id: null
    },
    data() {
      return {
        isLoading: false,
        endPoint: null,
        fields: [
          { key: 'payload', sortable: false, filterable: false},
          { key: 'attempts', sortable: false, filterable: false},
          { key: 'available_at', sortable: false, filterable: false},
          { key: 'created_at', sortable: false, filterable: false},
        ],
        payloadDetailsModal: 'show-payload-details-modal',
        job: null,
      }
    },
    methods: {
      showPayloadDetails(job) {
        this.job = job;
        this.$nextTick(() => this.$bvModal.show(this.payloadDetailsModal));
      },
    },
    created() {
      this.endPoint = '/scopes/' + this.scope_id + '/jobs';
    },
  }
</script>

<style scoped>

</style>
